module.exports = __webpack_public_path__ + "static/img/news_banner.04012f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_banner.png
// module id = RVWZ
// module chunks = 0